import ko from "knockout";
import { LogEntry } from "../components/LogEntry.js";

import { ScopedLogger } from "../utils/log.js";

const log = ScopedLogger("LogVM");

export class LogViewModel {
  constructor() {
    this.messages = ko.observableArray();
    // control expanded/collapsed state of log panel
    this.isLogCollapsed = ko.observable(false);
  }

  addLog(message, logLevel = "info") {
    const now = new Date();
    // Pass full Date object; LogEntry will format short and full timestamps
    const newEntry = new LogEntry(now, message, logLevel);
    this.messages.unshift(newEntry);
    log[logLevel](message);
  }
  // Toggle collapse/expand of the log body
  toggleLog() {
    this.isLogCollapsed(!this.isLogCollapsed());
  }
}
